import { Box, Button, Typography } from '@mui/material';
import { cloneDeep, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from '../../../../../components/ui-component/form-component/create-form/CreateForm';
import LoadingIconOnly from '../../../../../components/ui-component/loading/LoadingIconOnly';
import MuiSnackbar from '../../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import { useAuthentication } from '../../../../../context/AuthContext';
import GetRecord from '../../../../../lib/api/GetRecord';
import { PostRecord } from '../../../../../lib/api/PostRecord';
import PutRecord from '../../../../../lib/api/PutRecord';
import { APIS } from '../../../../../lib/constants/apis';
import { NOT_FOUND_ERROR_MESSAGE } from '../../../../../lib/constants/constant';
import Schema from '../../../../../lib/paths/person_FULL_Paths.json';
import { removeDataKeys, removeNullDeep } from '../../../../../utils/helper';
import PersonalDataValidator from './PersonalDataValidator';
let P = Schema.attributes;

// const formStruc = [{ fields: [P.Titel] }, { fields: [P.Vorname, P.Nachname] }, { fields: [P.E_Mail, P.Fax] }, { fields: [P.Telefon] }];

const PersonalData: FC<{}> = () => {
	const { authenticatedData } = useAuthentication();
	const [loading, setLoading] = useState<boolean>(true);
	const [updateSuccess, setUpdateSuccess] = useState<boolean | null>(null);
	const [wsError, setWsError] = useState<boolean>(false);
	const [personData, setPersonData] = useState<Record<string, any>>({});
	const [formErrors, setFormErrors] = useState<Record<string, any>>({});

	const handleInputChange = (path: string, value: any) => {
		setUpdateSuccess(null);
		let personDataCopy = cloneDeep(personData);
		set(personDataCopy, path, value);
		setPersonData(personDataCopy);
	};
	const validatePersonData = () => {
		let errorObject = {};
		let errs = PersonalDataValidator.validate(personData);
		for (let error of errs) {
			set(errorObject, error.path, get(error, 'message'));
		}
		setFormErrors(errorObject);
		return Object.keys(errorObject).length === 0;
	};
	const handleUpdatePersonData = async () => {
		if (validatePersonData()) {
			let res = await PutRecord(APIS.Person, get(authenticatedData, 'personId'), { data: get(personData, 'attributes') });
			if (get(res, 'data.id')) {
				let pushNotificationData = { data: { entities: [{ api: APIS.Person, id: get(res, 'data.id') }] } };
				await PostRecord(APIS.PushNotificaiton, pushNotificationData);
				setUpdateSuccess(true);
			}
		}
	};

	useEffect(() => {
		const fetchPerson = async () => {
			setLoading(true);
			try {
				let res = await GetRecord(APIS.Person, get(authenticatedData, 'personId'), ['Adressdaten']);
				console.log('PERSON DATA', res);
				setPersonData(removeNullDeep(removeDataKeys(get(res, 'data', {}))));
			} catch (err) {
				console.error('ERROR Fetching Person ', err);
				setWsError(true);
			} finally {
				setLoading(false);
			}
		};
		fetchPerson();
	}, [authenticatedData]);

	if (loading) return <LoadingIconOnly />;

	return (
		<>
			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage={NOT_FOUND_ERROR_MESSAGE} error={wsError} />
			<MuiSnackbar showSnackbar={updateSuccess} closeSnackbar={() => setUpdateSuccess(null)} alertMessage='Daten wurde aktualisiert' />
			<Typography variant='h3' component='h2'>
				Persönliche Daten
			</Typography>
			<CreateForm
				formStruc={formStruc()}
				formValues={personData}
				formErrors={formErrors}
				updateFormValuesFunc={handleInputChange}
				api={APIS.Person}
			/>

			<Box sx={{ textAlign: 'right', mt: '2rem' }}>
				<Button onClick={handleUpdatePersonData}>Aktualisieren</Button>
			</Box>
		</>
	);
};
export default PersonalData;

const formStruc = () => {
	return [
		{
			fields: [P.Titel, { ...P.Geschlecht, required: true }],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Vorname, required: true },
				{ ...P.Nachname, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Geburtsdatum, label: 'Geburtsdatum *', required: true },
				{ ...P.Staatsbuergerschaft, required: true },
			],

			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.E_Mail, required: true, isDisabled: true },
				{ ...P.Telefon, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Adressdaten.schema.attributes.Strasse_Und_Hausnummer, required: true },
				{ ...P.Adressdaten.schema.attributes.PLZ, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Adressdaten.schema.attributes.Ort, required: true },
				{ ...P.Adressdaten.schema.attributes.Bundesland, required: true },
			],
			userProps: { columnToDivide: 1 },
		},
	];
};
